export const messages = {
  en: {
    complaintDetail: {
      title: 'Complaint Details',
      workflow: 'Workflow',
      evaluation: 'Evaluation',
      type: 'Type'
    },
    complaintDetailInfo: {
      orderNo: 'Order No:',
      type: 'Type:',
      house: 'House:',
      contact: 'Contact:',
      phone: 'Phone:',
      status: 'Status:',
      createTime: 'Create Time:',
      content: 'Content:',
      photos: 'photos:'
    },
    complaintDetailEvent: {
      type: 'Type',
      operator: 'Operator',
      remark: 'Remark',
      time: 'Time',
      submit: 'Submit',
      process: 'Process',
      evaluate: 'Evaluate',
      reply: 'Reply'
    },
    complaintDetailAppraise: {
      userName: 'User Name',
      content: 'Content',
      score: 'Score',
      status: 'Status',
      time: 'Time',
      replyUser: 'Reply User',
      replyContent: 'Reply Content',
      operation: 'Operation',
      reply: 'Reply',
      waitReply: 'Wait Reply',
      replied: 'Replied'
    },
    replyComplaintAppraise: {
      title: 'Reply Evaluation',
      content: 'Content',
      placeholder: 'Required, please enter reply content',
      required: 'Reply content is required',
      maxLength: 'Reply content exceeds 500 characters',
      success: 'Reply successfully'
    },
    complaintDetailType: {
      typeName: 'Type Name',
      notifyWay: 'Notify Way',
      appraiseReply: 'Appraise Reply',
      handler: 'Handler',
      createTime: 'Create Time',
      sms: 'SMS',
      wechat: 'WeChat',
      autoReply: 'Auto Reply',
      manualReply: 'Manual Reply'
    }
  },
  zh: {
    complaintDetail: {
      title: '投诉详情',
      workflow: '工单流转',
      evaluation: '工单评价',
      type: '工单类型'
    },
    complaintDetailInfo: {
      orderNo: '订单编号：',
      type: '类型：',
      house: '房屋：',
      contact: '联系人：',
      phone: '联系电话：',
      status: '状态：',
      createTime: '创建时间：',
      content: '投诉内容：',
      photos: '投诉图片：'
    },
    complaintDetailEvent: {
      type: '类型',
      operator: '操作人',
      remark: '说明',
      photos: '回复图片',
      time: '时间',
      submit: '提交',
      process: '投诉处理',
      evaluate: '评价',
      reply: '评价回复'
    },
    complaintDetailAppraise: {
      userName: '用户名称',
      content: '评价内容',
      score: '评价得分',
      status: '评价状态',
      time: '评价时间',
      replyUser: '回复人',
      replyContent: '回复内容',
      operation: '操作',
      reply: '回复',
      waitReply: '待回复',
      replied: '已回复'
    },
    replyComplaintAppraise: {
      title: '回复评价',
      content: '内容',
      placeholder: '必填，请填写回复内容',
      required: '回复内容不能为空',
      maxLength: '回复内容超过500个字',
      success: '回复成功'
    },
    complaintDetailType: {
      typeName: '类型名称',
      notifyWay: '通知方式',
      appraiseReply: '评价回复',
      handler: '处理人',
      createTime: '创建时间',
      sms: '短信',
      wechat: '微信',
      autoReply: '自动回复',
      manualReply: '人工回复'
    }
  }
}